var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 2.72223C16.5345 2.72223 17.7782 3.96588 17.7782 5.50001V10.0552C17.4262 9.87531 17.0544 9.7285 16.6671 9.61893V7.16667H3.33377V15.5C3.33377 16.4205 4.07996 17.1667 5.00043 17.1667H9.11936C9.22892 17.554 9.37573 17.9258 9.55567 18.2778H5.00043C3.46631 18.2778 2.22266 17.0341 2.22266 15.5V5.50001C2.22266 3.96588 3.46631 2.72223 5.00043 2.72223H15.0004ZM15.0004 3.83334H5.00043C4.07996 3.83334 3.33377 4.57953 3.33377 5.50001V6.05556H16.6671V5.50001C16.6671 4.57953 15.9209 3.83334 15.0004 3.83334Z",
    fill: "#FC0D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7776 13.8333C17.7776 16.2879 15.7877 18.2778 13.3331 18.2778C10.8785 18.2778 8.88867 16.2879 8.88867 13.8333C8.88867 11.3787 10.8785 9.38889 13.3331 9.38889C15.7877 9.38889 17.7776 11.3787 17.7776 13.8333ZM13.3331 14.5317L14.4654 15.664C14.6583 15.8568 14.9709 15.8568 15.1638 15.664C15.3566 15.4712 15.3566 15.1585 15.1638 14.9656L14.0315 13.8333L15.1638 12.7011C15.3566 12.5082 15.3566 12.1955 15.1638 12.0026C14.9709 11.8098 14.6583 11.8098 14.4654 12.0026L13.3331 13.135L12.2009 12.0026C12.008 11.8098 11.6953 11.8098 11.5024 12.0026C11.3096 12.1955 11.3096 12.5082 11.5024 12.7011L12.6347 13.8333L11.5024 14.9656C11.3096 15.1585 11.3096 15.4712 11.5024 15.664C11.6953 15.8568 12.008 15.8568 12.2009 15.664L13.3331 14.5317Z",
    fill: "#FC0D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationCancelled);
export default __webpack_public_path__ + "static/media/reservation-cancelled.5715debbf75bc27015cd1d5b3caa35dd.svg";
export { ForwardRef as ReactComponent };